import {animateInViewport} from '../transition'

$('.media-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')

  const swiper = new Swiper(this, {
    navigation: {
      nextEl: $container.find('.carousel-next')[0],
      prevEl: $container.find('.carousel-previous')[0],
    },
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: $container.find('.carousel-pagination')[0],
      clickable: true, // makes bullets clickable
    },
  })

  $container.find('.carousel-buttons a').on('click', function (e) {
    e.preventDefault()

    $(this).addClass('active').siblings().removeClass('active')

    const index = +$(this).data('slide-index')
    if (!isNaN(index)) swiper.slideTo(index)
  })

  swiper.on('slideChange', function () {
    const activeIndex = swiper.activeIndex

    $container
      .find('.carousel-buttons a')
      .removeClass('active')
      .filter('[data-slide-index="' + activeIndex + '"]')
      .addClass('active')
  })
})

$('.hero-carousel-container').each(function () {
  const $group = $(this)
  const $s1 = $group.find('.hero-image-carousel') // master
  const $s2 = $group.find('.hero-title-carousel') // +1 (vertical)
  const $s3 = $group.find('.hero-title-2-carousel') // -1 (vertical)
  const $s4 = $group.find('.hero-content-carousel') // same as s1
  const $timeline = $group.find('.hero-timeline') // <-- progress bar element

  if (!$s1.length || !$s2.length || !$s3.length || !$s4.length) return

  const totalSlides = $s1[0].querySelectorAll('.swiper-slide')?.length
  const speed = 900 // fade duration
  const delay = 5000 // total cycle delay (includes fade)
  const baseLocked = {
    allowTouchMove: false,
    simulateTouch: false,
    grabCursor: false,
  }

  const verticalSwiperOptions = {
    loop: true,
    direction: 'vertical',
    spaceBetween: 24,
    speed,
    autoplay: false,
    ...baseLocked,
  }

  $group.find('.carousel-next').on('click', function () {
    s1.slideNext()
    s2.slideNext()
    s3.slideNext()
    s4.slideNext()
    animateInViewport
  })

  $group.find('.carousel-previous').on('click', function () {
    s1.slidePrev()
    s2.slidePrev()
    s3.slidePrev()
    s4.slidePrev()
    animateInViewport
  })

  // --- Swipers ---
  const s1 = new Swiper($s1[0], {
    effect: 'fade',
    fadeEffect: {crossFade: true},
    speed,
    loop: true,
    autoplay: false,
    ...baseLocked,
  })
  const s2 = new Swiper($s2[0], {
    ...verticalSwiperOptions,
    initialSlide: totalSlides - 1,
  })
  const s3 = new Swiper($s3[0], {
    ...verticalSwiperOptions,
    initialSlide: 1,
  })

  const $slides = $s4.find('.swiper-slide')

  // Function to update the container height based on the tallest slide
  const updateHeight = () => {
    let maxHeight = 0
    $slides.each(function () {
      const h = $(this).find('.hero-content-slide').innerHeight()
      if (h > maxHeight) maxHeight = h
    })
    $s4.height(maxHeight)
  }

  // Initial height calculation
  updateHeight()

  // Debounce resize handling
  let resizeTimer
  $(window).on('resize', function () {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(updateHeight, 150)
  })

  // Initialize Swiper after initial height is set
  const s4 = new Swiper($s4[0], {
    ...verticalSwiperOptions,
  })

  // --- Timeline animation ---
  let isHovering = false
  function startTimeline(fromPercent = 0) {
    $timeline
      .stop(true)
      .css({height: `calc(100% * ${fromPercent})`})
      .animate({height: '100%'}, delay * Math.max(0, 1 - fromPercent), 'linear', () => {
        s1.slideNext()
        s2.slideNext()
        s3.slideNext()
        s4.slideNext()
        animateInViewport()
      })
  }

  // --- Events ---
  s1.on('slideChangeTransitionStart', function () {
    $timeline.stop(false, false)
  })
  s1.on('slideChangeTransitionEnd', function () {
    if (isHovering) {
      $timeline.stop(true).css({height: 0})
    } else {
      startTimeline()
    }
  })

  $group.find('.hero-carousels').hover(
    () => {
      isHovering = true
      $timeline.stop(false, false)
    },
    () => {
      isHovering = false
      startTimeline($timeline.height() / $timeline.parent().height())
    },
  )

  startTimeline()
})

$('.image-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')

  const swiper = new Swiper(this, {
    grabCursor: true,
    centeredSlides: true,
    loop: true,
    spaceBetween: 10,
    slidesPerView: 1.1,
    breakpoints: {
      1024: {
        spaceBetween: 20,
        slidesPerView: 1.525,
      },
    },
    initialSlide: 1,
    navigation: {
      nextEl: $container.find('.carousel-next')[0],
      prevEl: $container.find('.carousel-previous')[0],
    },
  })
})
